import { useEffect } from 'react';
import { useShowAds } from '../hooks/useShowAds';

const PopunderScript = () => {
  const { showPopunder } = useShowAds();

  useEffect(() => {
    if (!showPopunder) {
      document.querySelectorAll(
        'script[src*="effectivegatecpm"], script[src*="profitablecpm"], script[id="popunder-script"]'
      ).forEach(el => el.remove());
      return;
    }

    if (!document.getElementById('popunder-script')) {
      const script = document.createElement('script');
      script.src = 'https://pl28935602.effectivegatecpm.com/0f/c0/6b/0fc06b4724a69c06555f8172ca6be9aa.js';
      script.async = true;
      script.id = 'popunder-script';
      document.head.appendChild(script);
    }

    return () => {
      const el = document.getElementById('popunder-script');
      if (el) el.remove();
    };
  }, [showPopunder]);

  return null;
};

export default PopunderScript;
